<div class="navbar-nav nav-primary">
  <ul class="mobile-content text-nowrap">
    <li
      *ngFor="let navItem of mainNav; first as isFirst"
      [ngClass]="{
        'active-menu':
          ((highlightOnlyFirstItem && isFirst) ||
            (selectedItem === navItem.id && !highlightOnlyFirstItem)) &&
          !isSlimHeader,
        'd-none d-md-block': navItem.id === 'flightstatus'
      }"
      class="nav-item"
    >
      <a
        (click)="
          selecedtNavItem(
            navItem.id,
            navItem.details?.legacyAppUrl,
            navItem.redirectMobile,
            navItem.redirectMobileUrl
          )
        "
        [attr.aria-expanded]="selectedItem === navItem.id"
        class="nav-link app-link nav-link-{{
          navItem.label | trim | lowercase
        }}"
        href="javascript:void(0);"
      >
        {{ navItem.label }}
      </a>
    </li>
  </ul>
</div>
